import { render } from "./AnnouncementIcon.vue?vue&type=template&id=48545636"
import script from "./AnnouncementIcon.vue?vue&type=script&lang=js"
export * from "./AnnouncementIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__